import { ArrowRight, CheckCircle, PhoneCall, WhatsappLogo } from "@phosphor-icons/react";
import { contactInfo, media } from "@/data/siteContent";

export default function Hero() {
  return (
    <section id="anasayfa" data-testid="hero-section" className="relative min-h-[92vh] overflow-hidden pt-28">
      <div data-testid="hero-parallax-background" data-parallax-speed="0.5" className="absolute -inset-y-16 inset-x-0 will-change-transform">
        <img
          data-testid="hero-background-image"
          src={media.hero}
          alt="Has Kırıkhan Nakliyat Kırıkhan Hatay profesyonel nakliyat kamyonu"
          loading="lazy"
          className="hero-kenburns h-full w-full object-cover object-center opacity-70"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-r from-black via-black/75 to-black/20" />
      <div className="absolute inset-0 industrial-grid opacity-45" />
      <div className="relative z-10 mx-auto grid min-h-[78vh] max-w-7xl items-center gap-12 px-6 py-16 lg:grid-cols-[1.1fr_0.9fr] lg:px-8">
        <div data-testid="hero-content" className="max-w-3xl">
          <p data-testid="hero-overline" className="hero-copy-motion mb-5 inline-flex rounded-full border border-orange-500/30 bg-orange-500/10 px-4 py-2 text-xs font-black uppercase tracking-[0.22em] text-orange-400 [--hero-delay:120ms]">
            Kırıkhan merkezli güvenli taşımacılık
          </p>
          <h1 data-testid="hero-title" className="hero-copy-motion font-heading text-4xl font-black tracking-tighter text-white [--hero-delay:200ms] sm:text-5xl lg:text-6xl">
            Has Kırıkhan Nakliyat: Bir evin değil, bir hayatın taşınmasıdır bu iş.
          </h1>
          <p data-testid="hero-description" className="hero-copy-motion mt-6 max-w-2xl text-base leading-relaxed text-slate-300 [--hero-delay:310ms] md:text-lg">
            Has Kırıkhan Nakliyat ile evden eve, ofisten ofise, asansörlü ve sigortalı taşımacılık hizmetlerini planlı, temiz ve zamanında alın.
          </p>
          <div data-testid="hero-cta-group" className="hero-copy-motion mt-9 flex flex-col gap-4 [--hero-delay:430ms] sm:flex-row">
            <a
              data-testid="hero-whatsapp-button"
              href={contactInfo.whatsappHref}
              target={contactInfo.whatsappHref.startsWith("http") ? "_blank" : undefined}
              rel={contactInfo.whatsappHref.startsWith("http") ? "noreferrer" : undefined}
              className="cta-pulse-glow relative inline-flex items-center justify-center gap-3 rounded-xl bg-[#25D366] px-7 py-4 font-black text-white transition-[transform,box-shadow,background-color] duration-300 hover:-translate-y-1 hover:bg-[#1DA851] hover:shadow-[0_8px_30px_rgba(37,211,102,0.25)]"
            >
              <WhatsappLogo size={22} weight="bold" /> WhatsApp: {contactInfo.phoneDisplay}
            </a>
            <a
              data-testid="hero-quote-button"
              href="#iletisim"
              className="cta-pulse-glow relative inline-flex items-center justify-center gap-3 rounded-xl bg-orange-500 px-7 py-4 font-black text-white transition-[transform,box-shadow,background-color] duration-300 hover:-translate-y-1 hover:bg-orange-600 hover:shadow-[0_8px_30px_rgba(249,115,22,0.3)]"
            >
              Fiyat Teklifi Al <ArrowRight size={20} weight="bold" />
            </a>
          </div>
        </div>

        <aside data-testid="hero-call-card" className="hero-copy-motion rounded-2xl border border-white/15 bg-[#121214]/95 p-6 shadow-2xl [--hero-delay:560ms] lg:ml-auto lg:max-w-sm">
          <p data-testid="hero-call-card-label" className="text-xs font-black uppercase tracking-[0.22em] text-orange-400">Acil taşıma hattı</p>
          <a data-testid="hero-phone-number" href={contactInfo.phoneHref} className="mt-4 flex items-center gap-3 font-heading text-2xl font-black text-white transition-colors duration-300 hover:text-orange-400">
            <PhoneCall size={28} weight="duotone" className="text-orange-500" /> {contactInfo.phoneDisplay}
          </a>
          <div data-testid="hero-benefit-list" className="mt-6 space-y-3">
            {["Ücretsiz ön görüşme", "Paketleme ve sök-tak desteği", "Kırıkhan’dan tüm Hatay’a hizmet"].map((item) => (
              <div key={item} data-testid={`hero-benefit-${item.toLowerCase().replaceAll(" ", "-")}`} className="flex items-center gap-3 text-sm font-semibold text-slate-300">
                <CheckCircle size={20} weight="fill" className="text-orange-500" /> {item}
              </div>
            ))}
          </div>
        </aside>
      </div>
    </section>
  );
}